import * as React from 'react';
import Tooltip from '../Tooltip';
import { validators } from '../../../utils/ehrValidators';
import { BlurEvent } from '../../../utils/customInterface';

interface Props {
    onChange: (value: string, field: string, stringToBoolean?: boolean) => void;
    onBlur?: () => void;
    field: string;
    label: string;
    value: string;
    id?: string;
    rules?: Object;
    extendClass?: Array<string>;
    stringToBoolean?: boolean;
    disabled?: boolean;
    triggerCheckError?: boolean;
    triggerClearError?: boolean;
    autoComplete?: string;
}

interface State {
    errors: Array<string>;
}

class SelectMenu extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            errors: new Array<string>()
        };
    }

    componentWillReceiveProps(nextProps: Props) {
        const { rules, triggerCheckError, triggerClearError } = this.props;
        if (triggerCheckError !== nextProps.triggerCheckError) {
            let result = new Array<string>();
            if (rules) {
                Object.keys(rules).forEach(rule => {
                    const error = validators(rule, rules[rule], nextProps.value);
                    if (error.length > 0) {
                        result.push(error);
                    }
                });
            }

            if (result.length !== 0) {
                this.setState({
                    errors: result
                });
            }
        }
        if (triggerClearError !== nextProps.triggerClearError) {
            this.setState({
                errors: new Array<string>()
            });
        }
    }

    handleChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        this.props.onChange(e.target.value, this.props.field, this.props.stringToBoolean);
    }

    handleBlur = (e: BlurEvent<HTMLSelectElement>): void => {
        const { rules, onBlur } = this.props;
        if (onBlur) {
            onBlur();
        }
        if (rules) {
            let result = new Array<string>();
            Object.keys(rules).forEach(rule => {
                const error = validators(rule, rules[rule], e.target.value);
                if (error.length > 0) {
                    result.push(error);
                }
            });
            this.setState({
                errors: result
            });
        }
    }

    handleFocus = (): void => {
        this.setState({
            errors: new Array<string>()
        });
    }

    render(): JSX.Element {
        const { extendClass, value, children, label, id, disabled, autoComplete } = this.props;
        const { errors } = this.state;
        const additionalClass = extendClass ? extendClass : ['', ''];

        return (
            <Tooltip
                wrapper="div"
                // wrap="div"
                title={errors.length > 0 ? label + errors.join(',') : ''}
                className={(errors.length > 0 ? 'has-error' : '') + (additionalClass[0] && (' ' + additionalClass[0]))}
                isValidation={true}
            >
                <select
                    {...id ? { id: id } : {}}
                    className={'form-control custom-select' + (additionalClass[1] && (' ' + additionalClass[1]))}
                    value={value ? value : ''}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    onFocus={this.handleFocus}
                    disabled={disabled}
                    autoComplete={autoComplete}
                >
                    {children}
                </select>
            </Tooltip>
        );
    }
}

export default SelectMenu;


// WEBPACK FOOTER //
// ./src/components/shared/SelectMenu/SelectMenu.tsx